import { ProductBuilderMachineContext } from '../types';
import { getBaseProduct } from './getBaseProduct';

type GetChainPositionOptions = (
  context: ProductBuilderMachineContext,
) => string[];

export const getChainPositionOptions: GetChainPositionOptions = context => {
  let chain_positions: string[] = [];
  const baseProduct = getBaseProduct(context);
  if (!baseProduct) return [];
  const {
    metafields: { chain_position },
  } = baseProduct;

  if (typeof chain_position === 'string') {
    chain_positions = JSON.parse(chain_position);
  } else {
    chain_positions = chain_position ? chain_position : [];
  }

  return chain_positions ? chain_positions : [];
};
